import { Pipe, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NumberFormatterService } from '../services/number/number-formatter.service';
import { LocaleService } from '../services/locale/locale.service';
import { BaseNumberPipe } from './base-number.pipe';
import type { PipeTransform } from '@angular/core';

import type { NumberPipeParameters } from './base-number.pipe';

/**
 * Formats number as a percentage value
 */
@Pipe({
  name: 'tdWbPercent'
})
export class PercentPipe extends BaseNumberPipe implements PipeTransform {
  private decimalPipe: DecimalPipe;

  constructor() {
    const translateService = inject<TranslateService>(TranslateService);
    const localeService = inject<LocaleService>(LocaleService);

    super(translateService);
    this.decimalPipe = new DecimalPipe(localeService.getLocale());
  }

  transform(value: number | undefined | null, pipeParameters?: NumberPipeParameters): string {
    return this.renderValue(value, BaseNumberPipe.applyParameterDefaults(pipeParameters, 'p'));
  }

  protected doFormat(val: number, _format: string | undefined, precision: number | undefined): string {
    return this.decimalPipe.transform(val, NumberFormatterService.getPrecisionString(precision)) + '%';
  }
}
